<template>
  <div id="video">
    <div class="video">
      <video
        ref="videoPlayer"
        class="video-js vjs-default-skin vjs-big-play-centered video-one"
        x-webkit-airplay="true"
        webkit-playsinline=""
        playsinline="true"
      ></video>
      <div class="info">
        <div class="title">标题：{{ video.title }}</div>
        <div class="from">来源：{{video.from}}</div>
        <van-tag color="#bbbbbb" plain v-if="video.hasWatched == 0"
          >未观看</van-tag
        >
        <van-tag color="#ffea00" plain v-else>已完成</van-tag>
      </div>

      <div class="question" v-if="showQuestion">
        <div class="title">{{question.question}}</div>
        <div class="options">
          <div class="option" v-for="(v, k) in question.options" :key="k" :class="optionKey == k ? 'active' : ''" @click="doOption(k)">{{ v }}</div>
        </div>

        <div class="submit_btn">
          <img src="https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628608445286281.png" alt="" @click="doSubmit">
        </div>
      </div>

      <div class="van-hairline--top notice">
        <van-notice-bar
          wrapable
          :scrollable="false"
          left-icon="volume-o"
          text="温馨提示：第一次观看完视频后+5分，答题正确再+5分！"
        ></van-notice-bar>
      </div>
    </div>
    

    <van-overlay :show="showIntegralSuccess" @click="showIntegralSuccess = false">
      <div class="wrapper" @click.stop>
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628411961255772.png" class="integral-img" alt="">
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628576386910863.png" class="to-answer" @click="showIntegralSuccess = false" alt="">
      </div>
    </van-overlay>
    
    <van-overlay :show="showWrong" @click="showWrong = false">
      <div class="wrapper">
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628621721143431.png" class="integral-img" alt="">
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628621719736101.png" class="to-answer" @click="showWrong = false" alt="">
      </div>
    </van-overlay>

    <van-overlay :show="showRight" @click="showRight = false">
      <div class="wrapper">
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628666053640496.png" class="integral-img" alt="">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import 'video.js/dist/video-js.css'
import { getVideoDetail } from '@/api/fanzha'
import {
  getFanzhaUserInfo,
  saveVideoHistoryWithIntegral,
  getRandQuestion,
  saveVideoQuestion
} from '@/api/fanzha'
import { Dialog, NoticeBar, Overlay, Toast } from 'vant'

import videojs from 'video.js'


export default {
  name: 'Video',
  data() {
    return {
      video: {},
      options: {
        height: 230,
        autoplay: false,
        controls: true,
        controlBar: {
          playToggle: true,
          captionsButton: false,
          chaptersButton: false,
          subtitlesButton: false,
          remainingTimeDisplay: true,
          progressControl: {
            seekBar: false
          },
          fullscreenToggle: false,
          playbackRateMenuButton: false
        },
        poster: '',
        sources: [
          {
            src: '',
            type: 'video/mp4'
          }
        ]
      },
      themeId: 3,
      deviceNo: '', //设备号
      showQuestion: false,
      showIntegralSuccess: false,
      question: {},
      optionKey: -1,
      optionKeys: ['A', 'B', 'C', 'D', 'E', 'F'],
      showWrong: false,
      showRight: false
    }
  },
  created() {
    getVideoDetail({ id: this.$route.params.id }).then((res) => {
      if (res.code == 1) {
        this.video = {
          id: this.$route.params.id,
          status: 0,
          title: res.data.title,
          poster: res.data.cover,
          src: res.data.url,
          from: res.data.from,
          hasWatched:res.data.hasWatched,
          videoHistory: res.data.videoHistory,
        }
        this.options.poster = this.video.poster
        this.options.sources[0].src = this.video.src
        let self = this
        this.player = videojs(
          this.$refs.videoPlayer,
          this.options,
          function onPlayerReady() {
            console.log('onPlayerReady', this)
            // this.controlBar.progressControl.disable();
            this.on('ended', () => {
              self.onPlayEnded()
            })
          }
        )
      }
    })
  },
  mounted() {

    getFanzhaUserInfo({themeId: this.themeId}).then((res) => {
      if (res.code == 1 && res.data == null) {
        this.$route.push({
          path: `/fanzha/list`
        })
      }
    })
  
    // 获取设备号
    let self = this;
    let CP = window.CP
    CP.getDeviceInfo({
      completed: function(data){
         // data > {device_no:'',system:'',system_version:'',device_type:'',timestamp: '',signature：'', app: '', version: '', networkType: '', statusBarHeight: ''}
         CP.tools.writelog('get_device_info', data);
         self.deviceNo = data.device_no;
      },
      cpIncompatible: function () {
         CP.tools.writelog('', '此环境不支持此方法');
      }
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    doSubmit(){
      if(this.optionKey < 0){
        Toast.fail("请选择一个选项");
      }else{
        if(this.doing) return false;
        this.doing = true;
        
        if(this.optionKeys[this.optionKey] == this.question.answer){
          if(this.video.videoHistory.question_id){
            Toast.success("回答正确");
            this.showQuestion = false;
            this.doing = false;
            this.optionKey = -1;
          }else{
            saveVideoQuestion({theme_id: this.themeId, question_id: this.question.id, video_id: this.video.id}).then((res) => {
              if(res.code == 1){
                this.video.videoHistory.question_id = this.question.id;
                this.showRight = true;
              }else{
                Toast.fail(res.msg);
              }
              this.optionKey = -1;
              this.showQuestion = false;
              this.doing = false;
            });
          }
        }else{
          this.showQuestion = false;
          this.showWrong = true;
          this.optionKey = -1;
          this.doing = false;
        }
      }
    },
    doOption(key) {
      // console.log(key)
      this.optionKey = key;
    },
    onPlayEnded() {
      let postData = { videoId: this.$route.params.id, themeId: this.themeId};
      if(this.video.hasWatched == 0){
        postData.integral = 5;
      
        //上报视频播放记录
        saveVideoHistoryWithIntegral(postData).then((res) => {
          if(res.code == 1){
            this.video.hasWatched = 1;
            this.video.videoHistory = res.data;

            this.showIntegralSuccess = true;
          }
          console.log('上报视屏播放记录')
        })
        
        console.log('ended')
      }

      getRandQuestion({theme_id: this.themeId, limit: 1}).then((res) => {
        if(res.code == 1){
          this.question = res.data[0];
          this.showQuestion = true;
        }
      })
      
    },
    
    
  }
}
</script>

<style lang="less" scoped>
.video-js {
  width: 100%;
}

.video {
  .video-one {
    border: 10px solid #3651a3;
    border-radius: 10px;
  }
  .info {
    padding: 5px;
    margin-bottom: 10px;
  }
  .notice {
    padding-top: 10px;
  }
  .question {
    background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628603289590857.png);
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 60px 20px;
    height: 450px;
    .title {
      color: #000;
      font-weight: bold;
    }
    .options {
      color: #0e4ed1;
      margin-top: 10px;
      padding: 0 10px;
      .option {
        margin-bottom: 20px;
        padding: 5px 10px;
        border-radius: 10px;
      }
      .active {
        background-color: #3651a3;
        color: #fff;
      }
    }
    .submit_btn {
      width: 30vw;
      margin: 20px auto auto auto;
      img {
        width: 100%;
      }
    }
  }
}

.wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .integral-img {
    width: 60%;
  }
  .to-answer {
    margin-top: 10px;
    width: 30%;
  }

}


</style>
